/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchOperationReqVo
 */
export interface BatchOperationReqVo {
    /**
     * SPU ID列表
     * @type {Array<number>}
     * @memberof BatchOperationReqVo
     */
    spuIds?: Array<number>;
    /**
     * SKU ID列表
     * @type {Array<number>}
     * @memberof BatchOperationReqVo
     */
    skuIds?: Array<number>;
}

/**
 * Check if a given object implements the BatchOperationReqVo interface.
 */
export function instanceOfBatchOperationReqVo(value: object): value is BatchOperationReqVo {
    return true;
}

export function BatchOperationReqVoFromJSON(json: any): BatchOperationReqVo {
    return BatchOperationReqVoFromJSONTyped(json, false);
}

export function BatchOperationReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchOperationReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'spuIds': json['spuIds'] == null ? undefined : json['spuIds'],
        'skuIds': json['skuIds'] == null ? undefined : json['skuIds'],
    };
}

export function BatchOperationReqVoToJSON(json: any): BatchOperationReqVo {
    return BatchOperationReqVoToJSONTyped(json, false);
}

export function BatchOperationReqVoToJSONTyped(value?: BatchOperationReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spuIds': value['spuIds'],
        'skuIds': value['skuIds'],
    };
}

